import appService from 'src/pl.service';
import { GET_PRODUCT_PERMISSIONS } from 'src/store/actions/types';

/**
 * retrieves the "product permissions" from the API and
 * commits the data to the store using the GET_PRODUCTS_PERMISSIONS action type
 */
export const getProductPermissions = async ({ commit }) =>
  commit(GET_PRODUCT_PERMISSIONS, await appService.getProductPermissions());
